import { render } from "./P054.vue?vue&type=template&id=073f7090&scoped=true"
import script from "./P054.vue?vue&type=script&lang=js"
export * from "./P054.vue?vue&type=script&lang=js"

import "./P054.vue?vue&type=style&index=0&id=073f7090&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073f7090"]])

export default __exports__